import Checker from 'components/Checker';
import config from 'config';
import { useQRCode } from 'next-qrcode';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'reducer';
import { errorAlert, successAlert } from 'reducer/slices/alertSlice';
import { bottomDrawer } from 'reducer/slices/drawerSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import gather from 'tools/gather';
import utils from 'tools/utils';

const tabTitle = {
  buy: 'خرید هات ووچر',
  // sell: 'فروش هات ووچر',
  wallet: 'شارژ کیف پول',
};

const LIST = [
  { s: 'UUSD', t: 'یو ووچر' },
  { s: 'Utopia', t: 'یوتوپیا' },
  { s: 'TRX', t: 'ترون' },
  { s: 'USDT-TRC20', t: 'تتر ترون' },
  { s: 'USDT-BSC', t: 'تتر بایننس' },
];

const LIST_BUY = [{ s: 'HotVoucher', t: 'کیف پول' }, ...LIST];
const LIST_SELL = [{ s: 'HotVoucher', t: 'هات ووچر' }, ...LIST];

const Form = () => {
  const allData = useAppSelector((state) => state.data);
  const useUser = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const [code, setCode] = useState('');
  const [walletAddress, setWalletAddress] = useState('');
  const [amount, setAmount] = useState('');
  const [email, setEmail] = useState('');
  const [coin, setCoin] = useState('UUSD');
  const [tab, setTab] = useState(tabTitle.buy);
  const { Image } = useQRCode();

  const reCoin = coin === 'Utopia' ? 'UUSD' : coin === 'USDT-TRC20' ? 'USDT' : coin;

  const price = allData?.data?.price?.find((e: any) => e.symbol === 'HotVoucher').rate;
  const rate = allData?.data?.swap?.find((e: any) => e.symbol === reCoin)?.swap?.find((e: any) => e.coin === 'HotVoucher')?.percent || 0;
  const rec = utils.toFixed(Number(1) * (rate / 100 + 1) || 0, 0);

  const copy = (value: string) => {
    navigator.clipboard.writeText(value);
    dispatch(successAlert('کپی شد'));
  };

  const chargeWallet = async () => {
    //
  };

  const showAddress = async (type: string) => {
    setWalletAddress('');

    const result = await gather(`${config.apiUrl}/wallet`, true).post({
      coin: reCoin,
      type: type,
    });

    if (result.code === 200) {
      setWalletAddress(result.data.address);
    } else {
      dispatch(errorAlert(config.errorCode['code_' + result?.message] ?? config.errorCode['errorFound']));
      setWalletAddress('');
    }
  };

  const buyHotUUSD = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/check${!useUser.profile.email ? '/guest' : ''}`, true).post({
      email: email,
      code: code,
      coin: 'UUSD',
      isDirect: tab === tabTitle.buy,
    });

    if (result.code === 200) {
      dispatch(successAlert('سفارش شما با موفقیت ثبت شد و در حال پردازش می باشد'));
      if (!useUser.profile.email) {
        window.history.pushState({}, '', '?check=' + result.data.ref + '&uId=' + result.data.uId);
        dispatch(bottomDrawer(<Checker check={result.data.ref} uId={result.data.uId} />));
      }
      setCode('');
      setEmail('');
    } else {
      dispatch(errorAlert(config.errorCode['code_' + result?.message] ?? config.errorCode['errorFound']));
    }

    dispatch(hideLoading());
  };

  const buyHot = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/buy`, true).post({
      amount: amount,
      coin: coin,
    });

    if (result.code === 200) {
      dispatch(successAlert('سفارش شما با موفقیت ثبت شد و در حال پردازش می باشد'));
    } else {
      dispatch(errorAlert(config.errorCode['code_' + result?.message] ?? config.errorCode['errorFound']));
    }

    dispatch(hideLoading());
  };

  const sellHot = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/check`, true).post({
      code: code,
      coin: 'HotVoucher',
      type: 'wallet',
    });

    if (result.code === 200) {
      dispatch(successAlert('سفارش شما با موفقیت ثبت شد و در حال پردازش می باشد'));
      setCode('');
    } else {
      dispatch(errorAlert(config.errorCode['code_' + result?.message] ?? config.errorCode['errorFound']));
    }

    dispatch(hideLoading());
  };

  const coinOption = (type: 'buy' | 'wallet') => {
    const rows: any = [];

    (type === 'buy' ? LIST_BUY : LIST_SELL).forEach((v, k) => {
      let icon = v.s;
      if (icon === 'USDT-TRC20') {
        icon = 'USDT';
      } else if (icon === 'Utopia') {
        icon = 'UUSD';
      } else if (icon === 'Wallet') {
        icon = 'HotVoucher';
      }

      rows.push(
        <div onClick={() => setCoin(v.s)} className={coin === v.s ? 'active' : ''} key={k}>
          <img crossOrigin='anonymous' src={`${config.apiUrl}/icons/${icon.toLowerCase()}.png`} />
          <div>
            <i>{v.t}</i>
          </div>
        </div>,
      );
    });

    return rows;
  };

  const tabOption = () => {
    const rows: any = [];

    Object.entries(tabTitle).forEach(([k, v]) => {
      rows.push(
        <span className={tab === v ? 'inActiveTabs' : ''} onClick={() => setTab(v)} key={k}>
          {v}
        </span>,
      );
    });

    return rows;
  };

  useEffect(() => {
    const params = new URL(document.location.toString()).searchParams;
    const check = params.get('check');
    const uId = params.get('uId');
    if (check) {
      dispatch(bottomDrawer(<Checker check={check} uId={uId} />));
    }
  }, []);

  useEffect(() => {
    if (reCoin !== 'HotVoucher' && useUser.profile.email) {
      showAddress(tab === tabTitle.buy ? 'direct' : 'wallet');
    }
  }, [reCoin, tab]);

  return (
    <>
      <div className='form'>
        <div className='tabs_list'>{tabOption()}</div>
        {tab === tabTitle.buy ? (
          <>
            <div className='inside_form'>
              <div className='inp_large'>{coinOption('buy')}</div>
              <div className='inside_form inside_formLarge'>
                {!useUser.profile.email && coin !== 'UUSD' ? (
                  <span className='please_login'>جهت خرید هات ووچر وارد سایت شوید</span>
                ) : (
                  <>
                    {coin === 'HotVoucher' ? (
                      <div className='inp_top'>
                        <span>مقدار (حداقل ۲۰ هزار تومان) - موجودی: {utils.formatter(useUser.profile.balanceAmount || 0)} هات ووچر</span>
                        <input type='text' placeholder={`مقدار به ریال`} className='right_holder' value={amount} onChange={(e) => setAmount(e.target.value)} />
                      </div>
                    ) : coin === 'UUSD' ? (
                      <>
                        <div className='inside_form'>
                          <div className='inp_top'>
                            <span>کد ووچر</span>
                            <input type='text' placeholder='yyyyyyyyyy' className='right_holder' value={code} onChange={(e) => setCode(e.target.value)} />
                          </div>
                        </div>
                        {!useUser.profile.email && (
                          <div className='inside_form'>
                            <div className='inp_top'>
                              <span>ایمیل</span>
                              <input
                                type='text'
                                placeholder='aaaa@bbbb.com'
                                className='right_holder'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    ) : walletAddress ? (
                      <div className='address_up'>
                        <span className={`please_login please_login_true`}>{walletAddress}</span>
                        <span className={`copy`} onClick={() => copy(walletAddress)}></span>
                        {walletAddress && <Image text={walletAddress} options={{ type: 'image/jpeg', quality: 1, margin: 2, width: 120 }} />}
                      </div>
                    ) : (
                      <span className={`please_login`}>لطفا صبر نمایید...</span>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className='inside_form inside_left_form'></div>
            <div className='inside_form inside_left_form'>
              <div className='detail_form'>
                {coin !== 'Wallet' ? `هر ${coin} معادل ${utils.formatter(rec)} هات ووچر می باشد` : `قیمت هات ووچر: ${utils.formatter(price)} ریال`}
              </div>
              <div className='btn_center' onClick={() => (coin === 'UUSD' ? buyHotUUSD() : buyHot())}>
                ثبت سفارش
              </div>
            </div>
          </>
        ) : (
          <>
            <div className='inside_form'>
              <div className='inp_large'>{coinOption('wallet')}</div>
              <div className='inside_form inside_formLarge'>
                {!useUser.profile.email ? (
                  <span className='please_login'>جهت شارژ کیف پول وارد سایت شوید</span>
                ) : (
                  <>
                    {coin === 'UUSD' || coin === 'HotVoucher' ? (
                      <div className='inside_form'>
                        <div className='inp_top'>
                          <span>کد ووچر</span>
                          <input type='text' placeholder='yyyyyyyyyy' className='right_holder' value={code} onChange={(e) => setCode(e.target.value)} />
                        </div>
                      </div>
                    ) : walletAddress ? (
                      <div className='address_up'>
                        <span className={`please_login please_login_true`}>{walletAddress}</span>
                        <span className={`copy`} onClick={() => copy(walletAddress)}></span>
                        {walletAddress && <Image text={walletAddress} options={{ type: 'image/jpeg', quality: 1, margin: 2, width: 120 }} />}
                      </div>
                    ) : (
                      <span className={`please_login`}>لطفا صبر نمایید...</span>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className='inside_form inside_left_form'></div>
            <div className='inside_form inside_left_form'>
              <div className='detail_form'>
                {coin !== 'HotVoucher' ? `هر ${coin} معادل ${utils.formatter(rec)} هات ووچر می باشد` : `قیمت هات ووچر: ${utils.formatter(price)} ریال`}
              </div>
              <div className='btn_center' onClick={() => chargeWallet()}>
                ثبت سفارش
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Form;
